import { createContext, useContext } from 'react';

import { AuthContextState } from './AuthContextState';

export const AuthContext = createContext({ isAuthenticated: false } as AuthContextState);

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
